export const tags = [
  "assessment-deep-dive",
  "assessment-deep-dive-details",
  "jnct-assignments-table",
  "course-header",
  "high-chart",
  "items-detailed-report",
  "jnct-assessment-attempt-learnosity-iframe",
  "jnct-assessment-detail-attempt-table",
  "jnct-assessment-detail-modal",
  "list-with-checkbox",
  "live-progress",
  "performance-report",
  "performance-by-item",
  "performance-by-learning-objective",
  "report-chart-row",
  "report-row",
  "jnct-student-deep-dive-chapter-select",
  "jnct-student-deep-dive-details",
  "jnct-student-overall",
  "student-submissions",
  "student-submissions-detail-modal",
  "email-students-modal",
] as const;
